import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=30cd4bc0&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd4bc0",
  null
  
)

export default component.exports